import { render, staticRenderFns } from "./CaseParticipants.vue?vue&type=template&id=532b21ef"
import script from "./CaseParticipants.vue?vue&type=script&lang=js"
export * from "./CaseParticipants.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports